export const isDigit = char => /[0-9]{1}/g.test(char);
